// 站点静态内容数据（虚构示例，仅用于展示网站结构与形式）

export interface GossipItem {
  id: number;
  title: string;
  summary: string;
  category: string;
  tag: string;
  date: string;
  heat: number; // 热度指数
  views: string;
  comments: string;
  year: number;
  status: string; // 进行中/已完结/热议中
}

export const categories = ['全部', '明星塌房', '综艺名场面', '品牌翻车', '红毯造型', '绯闻辟谣'];

export const events: GossipItem[] = [
  { id: 1, title: '顶流男主被曝机场冷脸怼粉，站姐集体脱粉回踩', summary: '一段不足十秒的机场视频引爆全网：某一线男演员因被围堵拍照而当众黑脸，几秒内相关话题阅读量突破五亿，其多年经营的人设面临开年以来最大一次考验。', category: '明星塌房', tag: '塌房预警', date: '2026-08-21', heat: 98, views: '5.2亿', comments: '41万', year: 2026, status: '热议中' },
  { id: 2, title: '三大卫视跨年晚会收视复盘：哪一台才是流量之王', summary: '跨年夜各台节目单与嘉宾名单先后流出，网友连夜制作对比长图。本期从收视峰值、弹幕互动、舞台破圈三个维度，把三家卫视的赢面拆开看。', category: '综艺名场面', tag: '年度盘点', date: '2026-01-02', heat: 91, views: '4.6亿', comments: '28万', year: 2026, status: '已完结' },
  { id: 3, title: '网红奶茶品牌联名翻车，客服怼人录音全网疯传', summary: '一家靠联名出圈的连锁茶饮品牌，因联名物料质量问题被消费者吐槽，随后一段疑似内部客服的激烈回应录音外流，品牌连夜致歉但舆论并未平息。', category: '品牌翻车', tag: '公关危机', date: '2025-11-17', heat: 94, views: '6.8亿', comments: '52万', year: 2025, status: '热议中' },
  { id: 4, title: '红毯生图大战：当女明星开始拒绝精修，谁赢了？', summary: '某电影盛典红毯上，多位女艺人主动晒出未修图直出照，拒绝官方精修，话题迅速刷屏。生图与精修的对比引发全网关于"真实审美"的大讨论。', category: '红毯造型', tag: '审美风向', date: '2026-06-11', heat: 87, views: '3.9亿', comments: '19万', year: 2026, status: '已完结' },
  { id: 5, title: '被拍到深夜同框，男女主恋情传闻冲上热搜第一', summary: '两位当红演员被拍到前后脚进入同一酒店，工作室始终保持沉默。双方粉丝则在广场"打架"，有人扒出旧年同款配饰佐证，也有人力挺是合作新剧炒作。', category: '绯闻辟谣', tag: '恋情疑云', date: '2026-07-28', heat: 96, views: '7.1亿', comments: '63万', year: 2026, status: '进行中' },
  { id: 6, title: '老戏骨公开批评流量演员轧戏，行业"潜规则"被摆上台面', summary: '一位德高望重的老演员在接受专访时直言部分年轻演员同时轧多部戏、用替身念台词，言论被剪辑放大后迅速出圈，引发关于行业生态的久违大讨论。', category: '明星塌房', tag: '行业大讨论', date: '2025-09-05', heat: 89, views: '5.5亿', comments: '38万', year: 2025, status: '已完结' },
  { id: 7, title: '音乐盛典颁错奖现场，获奖者台上神色瞬间成全网表情包', summary: '颁奖礼直播中主持人口误颁错奖项，获奖歌手一脸茫然地被请下台，画面被网友逐帧截图，诞生本年度最出圈的"名场面"表情包。', category: '综艺名场面', tag: '名场面', date: '2026-03-19', heat: 92, views: '6.2亿', comments: '45万', year: 2026, status: '已完结' },
  { id: 8, title: '美妆品牌被指辱女营销，广告片连夜下架重拍', summary: '某头部美妆品牌新一季广告因文案争议被网友集体抵制，代言人粉丝也下场要求解约。品牌方一天内连发两则声明，最终撤换创意团队重新拍摄。', category: '品牌翻车', tag: '营销事故', date: '2025-12-09', heat: 93, views: '6.1亿', comments: '47万', year: 2025, status: '热议中' },
  { id: 9, title: '国风造型天花板？女星汉服走红毯惊艳全场', summary: '一场主打国风的年度盛典上，多位女星身着考究汉服与现代改良礼服登场，其中一套织金马面裙造型被赞"教科书级别"，成功把东方美学送上热搜。', category: '红毯造型', tag: '国风高光', date: '2026-05-22', heat: 85, views: '3.4亿', comments: '16万', year: 2026, status: '已完结' },
  { id: 10, title: '被指与未成年粉丝私联，经纪公司紧急辟谣并保留追责权利', summary: '有网友爆料某选秀男艺人疑似私下回复未成年粉丝，迅速引发争议。随后经纪公司发布声明否认，并表示已收集证据、保留法律追责权利，事件仍有反转空间。', category: '绯闻辟谣', tag: '紧急辟谣', date: '2026-04-08', heat: 90, views: '4.9亿', comments: '33万', year: 2026, status: '热议中' },
  { id: 11, title: '上亿片酬明星演技翻车，导演直播内涵被剪辑疯传', summary: '一部大制作剧集上线后口碑崩塌，主演被指"面瘫式演技"。某导演在直播中疑似内涵高价演员，片段被逐句翻译解读，成为年末最热演技话题。', category: '明星塌房', tag: '演技质疑', date: '2025-10-14', heat: 88, views: '4.4亿', comments: '29万', year: 2025, status: '已完结' },
  { id: 12, title: '选秀节目黑幕实锤？前工作人员匿名爆料刷票内幕', summary: '一位自称前节目组工作人员的网友匿名发帖，曝光某选秀节目存在刷票与剪辑内幕，帖子迅速被搬运上热搜，节目组与平台方先后回应，事件仍在发酵。', category: '综艺名场面', tag: '节目黑幕', date: '2026-02-13', heat: 95, views: '6.7亿', comments: '58万', year: 2026, status: '进行中' },
  { id: 13, title: '男星为红毯造型连换三套礼服，造型师公开吐槽', summary: '一位男明星为追求"出圈造型"在红毯前临时连换三套礼服，合作造型师事后发文暗讽"改来改去最后还是穿回了第一套"，被粉丝团围攻后秒删。', category: '红毯造型', tag: '造型内幕', date: '2025-08-30', heat: 82, views: '2.8亿', comments: '11万', year: 2025, status: '已完结' },
  { id: 14, title: '综艺被剪出争议台词引战，节目组深夜补发完整版', summary: '一档旅行综艺因播出时剪掉关键语境，导致艺人一句台词被断章取义冲上热搜。节目组被迫深夜放出完整花絮还原真相，舆论才逐渐转向。', category: '综艺名场面', tag: '剪辑争议', date: '2026-07-03', heat: 86, views: '3.7亿', comments: '22万', year: 2026, status: '已完结' },
];

// 热门话题榜单（今日热榜）
export interface HotTopic {
  rank: number;
  title: string;
  heat: string;
  trend: 'up' | 'down' | 'new' | 'flat';
  category: string;
}

export const hotTopics: HotTopic[] = [
  { rank: 1, title: '顶流男主机场怼粉 站姐集体回踩', heat: '1879万', trend: 'new', category: '明星' },
  { rank: 2, title: '深夜同框恋情传闻 男女主保持沉默', heat: '1652万', trend: 'up', category: '恋情' },
  { rank: 3, title: '奶茶品牌联名翻车 客服录音流出', heat: '1498万', trend: 'up', category: '品牌' },
  { rank: 4, title: '选秀刷票内幕 前员工匿名爆料', heat: '1321万', trend: 'new', category: '综艺' },
  { rank: 5, title: '盛典颁错奖 获奖者表情包出圈', heat: '1187万', trend: 'flat', category: '名场面' },
  { rank: 6, title: '老戏骨痛批轧戏 行业潜规则引热议', heat: '1096万', trend: 'up', category: '行业' },
  { rank: 7, title: '美妆品牌辱女广告连夜下架', heat: '987万', trend: 'down', category: '品牌' },
  { rank: 8, title: '汉服红毯封神 织金马面裙出圈', heat: '864万', trend: 'up', category: '造型' },
  { rank: 9, title: '上亿片酬演技翻车 导演直播内涵', heat: '753万', trend: 'flat', category: '演技' },
  { rank: 10, title: '选秀艺人私联风波 公司紧急辟谣', heat: '641万', trend: 'down', category: '辟谣' },
];

// 吃瓜时间线
export interface TimelineNode {
  month: string;
  year: number;
  title: string;
  desc: string;
  heat: string;
}

export const timelineYears = [2026, 2025, 2024];

export const timeline: TimelineNode[] = [
  { month: '08月', year: 2026, title: '机场怼粉事件爆发', desc: '一线男演员机场冷脸视频流出，站姐集体脱粉，人设危机升级。', heat: '98.0' },
  { month: '07月', year: 2026, title: '深夜同框恋情疑云', desc: '两位当红演员被拍同框，恋情话题冲上热搜第一，双方均未回应。', heat: '96.4' },
  { month: '06月', year: 2026, title: '红毯"拒绝精修"风潮', desc: '女艺人们集体晒生图直出照，掀起关于真实审美的全网大讨论。', heat: '87.2' },
  { month: '05月', year: 2026, title: '国风盛典汉服出圈', desc: '织金马面裙造型被封教科书级别，东方美学强势破圈。', heat: '85.1' },
  { month: '04月', year: 2026, title: '选秀艺人私联风波', desc: '被指与粉丝私联，经纪公司紧急辟谣并保留追责权利。', heat: '90.3' },
  { month: '03月', year: 2026, title: '盛典颁错奖名场面', desc: '主持人颁错奖项，获奖者表情包刷屏，成年度最出圈名场面。', heat: '92.0' },
  { month: '02月', year: 2026, title: '选秀刷票内幕曝光', desc: '前节目员工匿名爆料刷票剪辑内幕，平台紧急回应。', heat: '95.1' },
  { month: '01月', year: 2026, title: '跨年晚会收视复盘', desc: '三大卫视跨年收视复盘长图刷屏，哪台成为流量之王。', heat: '91.6' },
  { month: '12月', year: 2025, title: '美妆品牌辱女营销', desc: '广告文案引争议被抵制，代言人粉丝下场，品牌连夜重拍。', heat: '93.4' },
  { month: '11月', year: 2025, title: '奶茶品牌联名翻车', desc: '联名物料质量问题引爆舆论，客服录音疯传致品牌致歉。', heat: '94.7' },
  { month: '10月', year: 2025, title: '上亿片酬演技质疑', desc: '大制作剧集口碑崩塌，导演直播内涵引年末最热演技话题。', heat: '88.6' },
  { month: '09月', year: 2025, title: '老戏骨痛批轧戏', desc: '老演员公开批评流量演员轧戏，行业"潜规则"被摆上台面。', heat: '89.5' },
  { month: '08月', year: 2025, title: '红毯临场换装风波', desc: '男星连换三套礼服，造型师发文暗讽后秒删。', heat: '82.4' },
  { month: '06月', year: 2024, title: '顶流官宣恋情引爆服务器', desc: '两位顶流同一天官宣，社交平台服务器一度崩溃，全年热度之最。', heat: '99.9' },
  { month: '05月', year: 2024, title: '综艺恶意剪辑引战', desc: '断章取义台词冲上热搜，节目组深夜放出完整版自证。', heat: '84.8' },
  { month: '03月', year: 2024, title: '品牌失言公关危机', desc: '某运动品牌代言人失言，解约风波贯穿整个季度。', heat: '90.9' },
  { month: '01月', year: 2024, title: '跨年舞台假唱争议', desc: '多人假唱被逐帧鉴定，相关讨论持续一整周。', heat: '83.5' },
];

// 大事件回顾（年度封面专题）
export interface MajorReview {
  id: number;
  title: string;
  sub: string;
  cover: string;
  year: string;
  num: string;
  desc: string;
}

export const majorReviews: MajorReview[] = [
  { id: 1, title: '塌房元年：从万人追捧到一夜翻车', sub: '2024 年度娱乐圈"塌房"全景回顾', cover: 'https://readdy.ai/api/search-image?query=editorial%20collage%20of%20crumbling%20celebrity%20spotlight%20stage%20with%20fragments%20falling%2C%20warm%20vermilion%20and%20amber%20and%20cream%20palette%2C%20stylized%20flat%20vector%20illustration%2C%20dramatic%20newspaper%20montage%20aesthetic%2C%20no%20text%2C%20high%20contrast%20graphic%20composition&width=900&height=600&seq=cover-collapse-01&orientation=landscape', year: '2024', num: 'TOP.01', desc: '这一年见证了太多从神坛坠落的瞬间。从言行失当到作品口碑崩塌，我们用一整年的事件档案，还原"人设"如何一步步走向失控。' },
  { id: 2, title: '流量退潮：观众终于开始用脚投票', sub: '2025 作品说话时代悄然到来', cover: 'https://readdy.ai/api/search-image?query=abstract%20editorial%20illustration%20of%20receding%20tidal%20wave%20with%20film%20clapperboard%20and%20star%20icon%2C%20warm%20crimson%20gold%20and%20cream%20palette%2C%20minimal%20flat%20vector%20art%2C%20cinematic%20collage%20vibe%2C%20no%20text%2C%20modern%20magazine%20cover%20style&width=900&height=600&seq=cover-retreat-02&orientation=landscape', year: '2025', num: 'TOP.02', desc: '当拼数据、拼流量的旧玩法失灵，越来越多观众回归作品本身。盘点这一年的爆款与哑火，我们看见审美正在被真正重塑。' },
  { id: 3, title: '红毯美学进化史：谁定义了亚洲时尚', sub: '2026 造型高光时刻全纪录', cover: 'https://readdy.ai/api/search-image?query=glamorous%20editorial%20illustration%20of%20red%20carpet%20spotlights%20with%20floating%20golden%20fabric%20and%20couture%20silhouettes%2C%20warm%20amber%20vermilion%20cream%20palette%2C%20stylish%20flat%20vector%20graphic%2C%20fashion%20magazine%20collage%2C%20no%20text%2C%20elegant%20high%20fashion%20mood&width=900&height=600&seq=cover-runway-03&orientation=landscape', year: '2026', num: 'TOP.03', desc: '从生图风潮到国风复兴，这一年红毯彻底告别"安全牌"。我们用一组组直出大片，重看属于东方审美的高光瞬间。' },
];

// 常见问题
export interface FaqItem {
  question: string;
  answer: string;
}

export const faqs: FaqItem[] = [
  { question: '吃瓜黑料的内容来源是哪里？', answer: '本站内容整理自公开的新闻报道、节目片段与社交平台公开讨论，我们会保留原出处线索供读者自行核对。我们坚持"只做搬运与梳理，不做事实断言"，对存在争议的信息会明确标注讨论中的状态。' },
  { question: '为什么你们的报道看起来比较中立？', answer: '吃瓜最重要的是理清来龙去脉，而不是急着站队。我们的时间线会完整保留事件各方的说法，把前因后果按时间排开，帮助你形成自己的判断，而不是被单方面情绪裹挟。' },
  { question: '发现某条盘点有误，可以申请更正吗？', answer: '当然可以。如果你发现我们的整理存在事实性错误，欢迎通过页面底部的反馈渠道联系我们，注明具体条目与正确信息，核实后我们会第一时间修正并标注勘误记录。' },
  { question: '如何参与话题讨论或投稿爆料？', answer: '你可以在对应条目下发表评论，也可以向我们提交公开讨论中你发现的热点线索。收到后编辑团队会先核实来源的公开性与可信度，确认无误后再整理上线。' },
  { question: '站内的时间线和年度汇总多久更新一次？', answer: '时间线随热点事件发酵实时补充，通常每天更新多次；年度汇总则在每月、每季度与年末进行三轮系统盘点，确保不漏掉任何值得回看的大事件。' },
  { question: '转载你们的内容需要注意什么？', answer: '欢迎在注明出处的前提下转载。我们的时间线与盘点均为整理性内容，请在转载时保留原始链接与勘误说明，避免在传播中断章取义造成二次误导。' },
];

// 翻车合集
export interface FlipCase {
  id: number;
  title: string;
  tag: string;
  summary: string;
  icon: string;
}

export const flipCases: FlipCase[] = [
  { id: 1, title: '口无遮拦型', tag: '言论翻车', summary: '前脚高谈阔论，后脚被逐帧打脸。从学霸人设到亲民路线，一句不合时宜的话足以让多年经营一夜归零。', icon: 'ri-voiceprint-line' },
  { id: 2, title: '人设崩塌型', tag: '形象翻车', summary: '学霸、好男人、耿直人设轮番崩塌。当镜头前的人设与镜头后的真实相撞，塌得越狠，回踩越猛。', icon: 'ri-user-unfollow-line' },
  { id: 3, title: '作品翻车型', tag: '口碑翻车', summary: '高开低走的剧集、雷声大雨点小的电影，演员再好也救不回一部烂剧本。口碑一旦崩塌，票房就是最好的答卷。', icon: 'ri-film-line' },
  { id: 4, title: '营销翻车型', tag: '品牌翻车', summary: '翻车文案、失当创意、失误联名，品牌危机来得猝不及防。一个糟糕的决策，足以点燃全网抵制情绪。', icon: 'ri-error-warning-line' },
  { id: 5, title: '公关翻车型', tag: '回应翻车', summary: '声明迟到、道歉敷衍、小号开撕，公关翻车往往比原始事件更致命。越描越黑，说的正是这种操作。', icon: 'ri-chat-voice-line' },
  { id: 6, title: '综艺名场面', tag: '现场翻车', summary: '颁错奖、说错话、临场抓马，综艺里的每一个失控瞬间，都是观众下饭的快乐源泉。', icon: 'ri-tv-line' },
];

// 年度汇总统计
export interface YearStat {
  year: string;
  events: string;
  hotWords: string[];
  label: string;
  topTopic: string;
  desc: string;
}

export const yearStats: YearStat[] = [
  { year: '2024', events: '312 件', label: '塌房元年', hotWords: ['塌房', '官宣', '假唱'], topTopic: '顶流同日官宣恋情', desc: '热闹与崩塌并存的一年。官宣霸屏服务器崩溃，也见证无数人设连夜翻车。' },
  { year: '2025', events: '428 件', label: '流量退潮', hotWords: ['作品说话', '公关', '品牌翻车'], topTopic: '上亿片酬演技质疑', desc: '观众用脚投票的一年。流量神话逐渐退潮，作品口碑开始成为真正的硬通货。' },
  { year: '2026', events: '205 件', label: '审美觉醒', hotWords: ['生图', '国风', '辟谣'], topTopic: '机场怼粉人设危机', desc: '审美的自我觉醒年。红毯拒绝精修、国风强势破圈，观众正在定义新的标准。' },
];

// 关于与口碑
export interface Testimonial {
  name: string;
  role: string;
  text: string;
  score: number;
}

export const testimonials: Testimonial[] = [
  { name: '吃瓜不打烊', role: '五年老用户', text: '从考研到上班，看你们的时间线已经成了习惯。每次大瓜都有人第一时间把来龙去脉捋清楚，太省心了。', score: 5 },
  { name: 'MelonQueen', role: '追星十年', text: '别的平台吵成一锅粥的时候，来这里看整理好的时间线最清醒。立场中立这一点，是真的难得。', score: 5 },
  { name: '熬夜冠军阿黎', role: '综艺爱好者', text: '年度汇总做得像杂志，翻车合集笑到停不下来。周末没事就躺床上刷一整晚，根本停不下来。', score: 4 },
  { name: '路人甲本甲', role: '吃瓜群众', text: '不站队、不带节奏，只把事件前后说清楚。在现在这个舆论场里，这样的内容越来越稀有了。', score: 5 },
];